const BootstrapIcons = [];

export default BootstrapIcons;
